// TSS vite/02 §"File-level constants" — routes referenced from JS (the header
// menu builder, hero CTAs, post-checkout navigation) live here, not inline.

export const ROUTES = {
    HOME:      '/',
    STORE:     '/tienda',
    TICKETS:   '/mis-numeros',
    CHANGELOG: '/changelog',
};

// Anchor inside the home page, used by the "ver resultados" CTA.
export const HOME_ANCHORS = {
    HISTORY: 'resultados',
};
